import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitRatingResponse} from '../../model/unit-rating-response';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import { ScheduleLineDrivePackageComponent } from '../schedule-line-drive-package/schedule-line-drive-package.component';
import { CoilResponseComponent } from '../coil-response/coil-response.component';


@Component({
    selector: 'app-candidate-rating-output',
    templateUrl: './candidate-rating-output.component.html',
    styleUrls: ['./candidate-rating-output.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CoilResponseComponent, ScheduleLineDrivePackageComponent]
})
export class CandidateRatingOutputComponent {

  readonly response = input.required<UnitRatingResponse>();
  readonly metricInput = input.required<boolean>();
  readonly isSureflow = input.required<boolean>();

  getAirflowUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.metricInput());
  }

}
